import * as React from "react";
import { Typography } from "@material-ui/core";
import "./Footer.css";
import resumeData from "../../../utils/resumeData";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-left">
        <Typography className="footer-name">{resumeData.name}</Typography>
      </div>
      <div className="footer-right">
        {Object.keys(resumeData.socials).map((key: string) => {
          const socialKey = key as keyof typeof resumeData.socials;
          return (
            <a
              href={resumeData.socials[socialKey].link as string}
              target="_blank"
              rel="noreferrer"
            >
              {resumeData.socials[socialKey].icon}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default Footer;
